import { makeStyles } from '@mui/styles';

export const usePageCustomRowStyle = makeStyles(() => ({
  cell: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
}));
